import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { palette } from '../../assets/styles/themes/tokens';

interface OwnCollectionOverviewWatchlistItemMetadataProps {
  schoolTypes: string[];
  classYears: number[];
  subjects: string[];
}

const OwnCollectionOverviewWatchlistItemMetadata = ({
  schoolTypes,
  subjects,
  classYears
}: OwnCollectionOverviewWatchlistItemMetadataProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        color: palette.text.secondary,
        marginTop: 'auto',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {schoolTypes?.length > 0 && (
        <Typography variant='caption' component='span'>
          {schoolTypes.join(', ') + ' • '}
        </Typography>
      )}
      {subjects?.length > 0 && (
        <Typography variant='caption' component='span'>
          {subjects.join(', ') + ' • '}
        </Typography>
      )}
      {classYears?.length > 0 && (
        <Typography variant='caption' component='span'>
          {t('Class years')}: {classYears.join(', ')}
        </Typography>
      )}
    </Box>
  );
};

export default OwnCollectionOverviewWatchlistItemMetadata;
